import { FileTextOutlined } from '@ant-design/icons';
import { RichiestaModuloDTO } from '@framework/api-client';
import {
  DownloadOmissisSubmissionButton,
  DownloadSubmissionModuleButton,
  ModuleValidationStateIconBadge,
  mapSubmissionModuleState,
} from '@framework/frontoffice-submission';
import { getModuleTitle } from '@framework/frontoffice-submission/src/module/getModuleTitle';
import { useTranslation } from '@framework/i18n';
import { FlexRow, LinkButton, generatePath } from '@framework/ui';
import { Space } from 'antd';
import {
  ElementSummaryWrapper,
  ElementTitle,
} from './SubmissionSummary.styles';

interface SubmissionSummaryModuleProps {
  submissionId: string | null | undefined;
  module: RichiestaModuloDTO;
  /** Se c'è più di un modulo, mostriamo il tasto di download per ogni modulo */
  hasInlineDownload?: boolean;
}

/**
 * Riga di dettaglio per il riepilogo di un modulo in una richiesta.
 * Ne viene mostrato il titolo e lo stato di validazione, più un pulsante
 * per permettere il download del PDF del modulo.
 */
export function SubmissionModuleSummary({
  module,
  submissionId,
  hasInlineDownload,
}: SubmissionSummaryModuleProps) {
  const { t } = useTranslation();

  return (
    <ElementSummaryWrapper>
      {/* //TODO: Aggiungere componente aggiornato per comportamento mobile */}
      <FlexRow
        style={{ width: '100%' }}
        gutter={12}
        left={
          <ElementTitle>
            <FileTextOutlined aria-hidden /> {getModuleTitle(module)}
          </ElementTitle>
        }
        right={
          <Space>
            {hasInlineDownload && (
              <DownloadSubmissionModuleButton
                submissionModuleId={module.id}
                submissionId={submissionId}
                isModuleSigned={module.idFileFirmato != null}
                inline
              />
            )}
            {hasInlineDownload && submissionId && (
              <DownloadOmissisSubmissionButton
                submissionId={submissionId}
                inline
              />
            )}
            {module.statoValidazione?.valido === false && (
              <LinkButton
                type="link"
                to={generatePath('/richieste/:id/moduli/:moduleId', {
                  id: submissionId!,
                  moduleId: module.id ?? '',
                })}
              >
                {t(
                  'module-tooltip-text.vai-al-modulo',
                  'Vai al modulo per correggere gli errori',
                )}
              </LinkButton>
            )}
            <ModuleValidationStateIconBadge
              validationState={module.statoValidazione}
              type={mapSubmissionModuleState(module.statoCompilazione)}
            />
          </Space>
        }
      />
    </ElementSummaryWrapper>
  );
}
